export default "__VITE_ASSET__DAeWVymr__"